module.exports = __webpack_public_path__ + "4353dce23ee770f2311ed103cc584c8a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/SubjectHandler/images/img-bg-1.svg
// module id = 897
// module chunks = 9